<template>
  <div class="input-group price-unit">
    <!-- Left button for $ -->
    <span
      class="input-group-text input-btn justify-content-center"
      :class="{
        active: !isPercent,
      }"
      @click="!isDisabled && setCurrency(false)"
      role="button"
      :aria-pressed="!isPercent"
      :aria-disabled="isDisabled"
    >
      $
    </span>

    <!-- Input field -->
    <input
      type="number"
      class="form-control"
      :class="{
        'text-end': isPercent,
        'text-start': !isPercent,
        'p-right': isPercent,
        'p-left': !isPercent,
      }"
      :disabled="isDisabled"
      @keydown="handleKeydown"
      v-model="internalValue"
      @input="validateInput"
      aria-label="Price input"
    />

    <!-- Right button for % -->
    <span
      class="input-group-text input-btn justify-content-center"
      :class="{
        active: isPercent,
      }"
      @click="!isDisabled && setCurrency(true)"
      role="button"
      :aria-pressed="isPercent"
      :aria-disabled="isDisabled"
    >
      %
    </span>
  </div>
</template>

<script>
export default {
  name: 'PriceUnitComponent',
  props: {
    value: {
      type: Number,
      required: true,
    },
    isPercent: {
      type: Boolean,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalValue: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
    internalValue(newValue) {
      this.$emit('update:value', newValue);
    },
    isPercent(newValue) {
      this.$emit('update:isPercent', newValue);
    },
  },
  methods: {
    setCurrency(percent) {
      this.$emit('update:isPercent', percent);
    },
    handleKeydown(event) {
      const value = event.target.value;
      const key = event.key;
      // For percentage, block . decimal
      if (this.isPercent && key === '.') {
        event.preventDefault();
        return;
      }
      // For dollars, limit up to 2 decimals
      if (
        !this.isPercent &&
        key !== 'Backspace' &&
        key !== 'Delete' &&
        key !== 'Tab' &&
        key !== 'ArrowLeft' &&
        key !== 'ArrowRight'
      ) {
        const parts = value.split('.');
        if (parts.length === 2 && parts[1].length >= 2 && /[0-9]/.test(key)) {
          event.preventDefault();
          return;
        }
      }
    },
    validateInput() {
      if (!this.isPercent) {
        // Validate for dollar amounts - must be greater than or equal to 0
        if (this.internalValue < 0) {
          this.internalValue = 0;
        }
        // prevent arithmetic overflow
        this.internalValue = Number(this.internalValue.toString().slice(0, 15));
      } else {
        // Validate for percentages - must be between 0 and above
        if (this.internalValue < 0) {
          this.internalValue = 0;
        }
        // prevent arithmetic overflow
        this.internalValue = Number(this.internalValue.toString().slice(0, 3));
      }
    },
  },
};
</script>

<style scoped>
.price-unit {
  width: 170px;
  margin-left: 10px;
}

.p-right {
  padding-right: 5px;
  text-align: right;
}

.p-left {
  padding-left: 5px;
  text-align: left;
}

.input-btn {
  min-width: 42px;
  text-align: center;
  transition: all 0.3s ease;
}

.input-btn.active,
.input-btn:hover {
  background-color: var(--bs-border-color);
  border-color: #dbdbdb;
}

/* Remove spinner arrows for number input */
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
